import React, { useContext, useEffect, useState, useRef } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import "./NavBar.css";
import blacksq from "../../img/blacksq.png";
import dancelogo from "../../img/icons/DanceLogIn.png";
import { UserContext } from "../../context/UserContext";
import NotificationService from "../NotificationService/NotificationService";
import useNotifications from "../../hooks/useNotifications";

const navLinks = [
  { to: "/", text: "Home", key: "home" },
  { to: "/events", text: "Events", key: "events" },
  { to: "/reviews", text: "Reviews", key: "reviews" },
  { to: "/about", text: "About", key: "about" },
  { to: "/blog", text: "Blog", key: "blog" },
  { to: "/goods", text: "Goods", key: "goods" },
];

const NavBar = () => {
  const { user, logout, setUserLoggedIn, setProfilePicture, profileCredentials } = useContext(UserContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const dropdownRef = useRef(null);

  const isLoggedIn = !!user;
  const { unreadCount, prioritySection } = useNotifications(isLoggedIn);


  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('userData'));
    if (userData && userData?.profilePicture) {
      setProfilePicture(userData?.profilePicture)
    } else {
      setProfilePicture(profileCredentials.profilePicture);
    }
  }, [user]);
  useEffect(() => {
    setProfilePicture(profileCredentials?.profilePicture)
  }
    , [profileCredentials?.profilePicture])



  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setProfileOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);


  const handleLogout = () => {
    logout();
    NotificationService.notifySuccess("User logged out.");
    setExpanded(false);
    setUserLoggedIn(false);
    setProfileOpen(!profileOpen);
    localStorage.removeItem("token");
    localStorage.removeItem("userData");
    navigate("/");
  };

  const handleNavLinkClick = () => {
    setExpanded(false);
  };

  const handleNotificationClick = () => {
    // Navigate to profile dashboard with the most urgent section open
    const section = prioritySection || 'kudos-received';
    navigate(`/profile?section=${section}&from=notification`);
    setExpanded(false);
  };

  return (
    <Navbar bg="transparent" expand="lg" expanded={expanded}>
      <Container fluid>
        <Navbar.Brand href="/">
          <img src={blacksq} alt="Logo" className="main-logo" />
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          onClick={() => setExpanded((prevExpanded) => !prevExpanded)}
        />

        {/* Nav icons outside Collapse so they're always visible on mobile */}
        <div className="nav-icons-container">
          {/* Notification Icon with Badge - only when logged in */}
          {isLoggedIn && (
            <div className="nav-bell-wrapper" onClick={handleNotificationClick}>
              <i className="bi bi-bell nav-icon-bell" title="Notifications"></i>
              {unreadCount > 0 && (
                <span className="notification-badge">
                  {unreadCount > 99 ? '99+' : unreadCount}
                </span>
              )}
            </div>
          )}

          {/* Profile Icon with label */}
          <div className="profile-icon-wrapper" ref={dropdownRef}>
            <div
              className="profile-icon-content"
              onClick={() => {
                if (!isLoggedIn) {
                  navigate("/login");
                  setExpanded(false);
                } else if (location.pathname === "/profile") {
                  setProfileOpen(!profileOpen);
                } else {
                  navigate("/profile");
                  setExpanded(false);
                }
              }}
            >
              <img
                src={dancelogo}
                alt={isLoggedIn ? "Profile" : "Sign in"}
                className="nav-icon-profile"
              />
              <span className="nav-profile-label">
                {isLoggedIn
                  ? (profileCredentials?.fullName || user?.fullName || profileCredentials?.username || user?.username || 'Profile')
                  : 'Sign in'}
              </span>
            </div>

            {/* Dropdown Menu - only show on profile page */}
            {isLoggedIn && profileOpen && location.pathname === "/profile" && (
              <div className="profile-dropdown">
                <Link
                  to="#"
                  className="dropdown-item"
                  onClick={handleLogout}
                >
                  <i className="bi bi-box-arrow-right"></i> Logout
                </Link>
              </div>
            )}
          </div>
        </div>

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto align-items-start">
            {navLinks.map(({ to, text, key }) => (
              <Nav.Link
                as={NavLink}
                to={to}
                key={key}
                className={({ isActive }) => (isActive ? "active" : "")}
                onClick={handleNavLinkClick}
              >
                {text}
              </Nav.Link>
            ))}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBar;
